/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-09-28
 * @brief EHP 회원가입 인증 화면 컴포넌트
 *
 ********************************************************************/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import "/static/css/login.css";
// recoil
import { getApiLangState } from "../../../recoil/langState";
import * as HttpUtil from "../../../utils/api/HttpUtil";
import * as CONST from "../../../utils/Const";
/**
 * @brief EHP 회원가입 인증 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function JoinDone(props) {
    // recoil
    const apiLang = useRecoilValue(getApiLangState);
    const userId = props.certification;
    const [success, setSuccess] = useState("");
    // 인증 발송 API
    function onClickJoinDone(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                httpMethod: "POST",
                appPath: "/api/v2/auth/key",
                appQuery: {
                    userId: userId,
                    language: apiLang,
                },
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSuccess(data.body);
                }
                else {
                    alert(data.errorList.map((err) => err.msg));
                }
            }
        });
    }
    // 재발송 API
    function onClickJoinDoneRe(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                httpMethod: "POST",
                appPath: "/api/v2/auth/key",
                appQuery: {
                    userId: userId,
                    language: apiLang,
                },
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSuccess(data.body);
                    alert("인증 메일 전송 되었습니다.");
                }
                else {
                    alert(data.errorList.map((err) => err.msg));
                }
            }
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "join-ok", className: "popup-layer js-layer layer-out hidden w560 login__popup" },
            React.createElement("div", { className: "popup__head" },
                React.createElement("h1", null, "\uD68C\uC6D0\uAC00\uC785 \uC778\uC99D"),
                React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => window.location.reload() },
                    React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            React.createElement("div", { className: "popup__body joinok-h webmail" },
                React.createElement("div", { className: "complete-txt" },
                    React.createElement("p", { className: "joinok" },
                        (success.length > 0) ? "" : "회원가입이 완료되었습니다.",
                        React.createElement("br", null),
                        "\u2018",
                        userId,
                        "\u2019 \uBA54\uC77C \uC8FC\uC18C\uB85C \uC778\uC99D \uBA54\uC77C\uC774 \uC804\uC1A1",
                        (success.length > 0) ?
                            "되었습니다."
                            :
                                "됩니다.",
                        React.createElement("br", null),
                        (success.length > 0) ?
                            "인증 후 계속 진행해 주세요."
                            :
                                "아래의 인증메일 발송 버튼을 클릭하세요."),
                    (success.length > 0) ?
                        React.createElement("button", { type: "button", onClick: onClickJoinDoneRe },
                            React.createElement("span", null, "  \uC778\uC99D\uBA54\uC77C \uC7AC\uBC1C\uC1A1"))
                        :
                            React.createElement("button", { type: "button", onClick: onClickJoinDone },
                                React.createElement("span", null, "  \uC778\uC99D\uBA54\uC77C \uBC1C\uC1A1")),
                    (success.length > 0) &&
                        React.createElement("div", { className: "joininfo" },
                            React.createElement("p", { className: "tit" }, "\uC778\uC99D \uBA54\uC77C\uC774 \uB3C4\uCC29\uD558\uC9C0 \uC54A\uC73C\uC168\uB098\uC694?"),
                            React.createElement("p", { className: "txt" }, "\uC2A4\uD338\uBA54\uC77C\uD568\uC744 \uD655\uC778\uD558\uAC70\uB098, \uC7A0\uC2DC\uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.")))))));
}
export default JoinDone;
